"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProgramContent = require("./ProgramContent");
Object.keys(_ProgramContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProgramContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProgramContent[key];
    }
  });
});